const getters = {
    token: (state) => state.user.token,
    userInfo: (state) => state.user.userInfo,
    rewardsPunishList: (state) => state.user.rewardsPunishList,
    whiteListRouters: (state) => state.permission.whiteListRouters,
    routers: (state) => state.permission.routers,
    barRouters: (state) => state.permission.barRouters,
}
export default getters
